/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiSaleFromJSON, ApiSaleToJSON, } from './ApiSale';
import { ApiSaleOrderStatusFromJSON, ApiSaleOrderStatusToJSON, } from './ApiSaleOrderStatus';
export function ApiSaleOrderStatusHistoryFromJSON(json) {
    return ApiSaleOrderStatusHistoryFromJSONTyped(json, false);
}
export function ApiSaleOrderStatusHistoryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'orderStatus': !exists(json, 'orderStatus') ? undefined : ApiSaleOrderStatusFromJSON(json['orderStatus']),
        'refundTotal': !exists(json, 'refundTotal') ? undefined : json['refundTotal'],
        'sale': !exists(json, 'sale') ? undefined : ApiSaleFromJSON(json['sale']),
        'saleId': !exists(json, 'saleId') ? undefined : json['saleId'],
    };
}
export function ApiSaleOrderStatusHistoryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'id': value.id,
        'orderStatus': ApiSaleOrderStatusToJSON(value.orderStatus),
        'refundTotal': value.refundTotal,
        'sale': ApiSaleToJSON(value.sale),
        'saleId': value.saleId,
    };
}
